<template lang="pug">
  div(class="custom-container")
    v-layout(justify-space-between)
      v-flex(shrink)
        v-layout(align-center class="pointer" @click="$emit('down', !showDown)")
          svg(height="30" viewBox="0 0 50 50")
            path(:d="sitePath"
                 :fill="showDown ? '#e53935' : '#999'"
                 stroke="black")
          span(class="ml-3" style="color: black;") Site with issues
      v-flex(shrink)
        v-layout(align-center class="pointer" @click="$emit('up', !showUp)")
          svg(height="30" viewBox="0 0 50 50")
            path(:d="sitePath"
                 :fill="showUp ? '#4caf50' : '#999'"
                 stroke="black")
          span(class="ml-3" style="color: black;") Normal site
      v-flex(shrink)
        v-layout(align-center)
          svg(width="30" viewBox="0 0 50 50")
            path(:d="storePath" fill="#90caf9" stroke="black")
          span(class="ml-3" style="color: black;") Franchises

</template>

<script>
import { SITE, HARDWARE_STORE } from "./icons.js";

export default {
  name: "map-legend",
  props: {
    showUp: {
      required: true,
      type: Boolean
    },
    showDown: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    sitePath () {
      return SITE;
    },
    storePath () {
      return HARDWARE_STORE;
    }
  }
};
</script>

<style scoped>
.custom-container {
  background-color: #fff;
  border: none;
  border-top: 1px solid grey;
  padding: 5px;
}
.pointer:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Map/Legend.vue